const LEGACY_ORG_FEATURES = {
  MGM_MEDICAL_BILLS_PAGE: 'mgm_medical_bills_page',
  MGM_CHECKS_PAGE: 'mgm_checks_page',
  MGM_CHECK_PRINTING: 'mgm_check_printing',
  MGM_ITRAK_AUTOFILL: 'mgm_itrak_autofill',
  MGM_WC_EMPLOYEE_HR_INTEGRATION: 'mgm_wc_employee_hr_integration',
  MGM_MEDICAL_BILL_PROVIDER_PROFESSION: 'mgm_medical_bill_provider_profession',
  MGM_WC_COMPENSATION_DATES: 'mgm_wc_compensation_dates',
  MGM_FORCE_RECORD_ONLY_PAYMENTS: 'mgm_force_record_only_payments',
  MGM_HIDE_CHECK_DESCRIPTION: 'mgm_hide_check_description',
  MGM_WC_CLAIM_TYPE_REQUIRED_TO_CLOSE: 'mgm_wc_claim_type_required_to_close',
  MGM_WC_LIGHT_DUTY_TRACK: 'mgm_wc_light_duty_track',
  MGM_GL_TOTAL_SETTLEMENT_AMOUNT: 'mgm_gl_total_settlement_amount',
  MGM_INTERNAL_PAYMENT_ATTACHMENTS: 'mgm_internal_payment_attachments',
  HOSPITALITY_ADVANCED_SEARCH: 'hospitality_advanced_search',
  HOSPITALITY_EMPLOYEE_ID_CLAIM_SEARCH: 'hospitality_employee_id_claim_search',
  HOSPITALITY_FNOL_SCREEN: 'hospitality_fnol_screen',
  HOSPITALITY_TABLE_LAYOUT: 'hospitality_table_layout',
  HOSPITALITY_CLAIM_TYPE_LABEL: 'hospitality_claim_type_label',
  HOSPITALITY_MEDICARE_ELIGIBILITY_FIELDS: 'hospitality_medicare_eligibility_fields',
  HOSPITALITY_HIDE_DOCUMENTATION_LINK: 'hospitality_hide_documentation_link',
  HOSPITALITY_NO_GUARDRAILS: 'hospitality_no_guardrails',
  HOSPITALITY_BOOST_CLAIM_LEVEL_COVERAGE_DECISION: 'hospitality_boost_claim_level_coverage_decision',
  HOSPITALITY_BOOST_NO_NOTIFICATION_STATE_RESTRICTION: 'hospitality_boost_no_notification_state_restriction',
  MGM_RW_EXTERNAL_CARRIER_REFERRALS: 'mgm_rw_external_carrier_referrals',
  MGM_RW_GL_PAYMENT_METHOD_TOGGLE: 'mgm_rw_gl_payment_method_toggle',
  MGM_RW_GL_CHECK_REQUEST_DOCUMENT: 'mgm_rw_gl_check_request_document',
  MGM_RW_OSHA_REPORTS: 'mgm_rw_osha_reports',
  RW_CIP_AUTOFILL: 'rw_cip_autofill',
  RW_WC_EMPLOYEE_JOB_DETAILS_REQUIRED: 'rw_wc_employee_job_details_required',
  INSHUR_US_LOB_PERFORMANCE_DASHBOARDS: 'inshur_us_lob_performance_dashboards',
  INSHUR_US_DATABANK_PHYSICAL_MAIL: 'inshur_us_databank_physical_mail',
  INSHUR_US_LOB_PHYSICAL_MAIL: 'inshur_us_lob_physical_mail',
  INSHUR_US_MEDLOGIX: 'inshur_us_medlogix',
  INSHUR_US_MGM_PHYSICAL_MAIL_CLASSIFICATION: 'inshur_us_mgm_physical_mail_classification',
  INSHUR_UK_XCEEDANCE_PHONE_CALLS_DASHBOARD: 'inshur_uk_xceedance_phone_calls_dashboard',
  INSHUR_UK_XCEEDANCE_TSC_PRODUCTION_DASHBOARD: 'inshur_uk_xceedance_tsc_production_dashboard',
  INSHUR_UK_SUB_ORG_SHARED_CLAIM_IDENTIFIER: 'inshur_uk_sub_org_shared_claim_identifier',
  INSHUR_UK_MOI_EMAIL_TEMPLATE: 'inshur_uk_moi_email_template',
  XCEEDANCE_PHYSICAL_MAIL_TYPE_FIELD: 'xceedance_physical_mail_type_field',
  XCEEDANCE_VOID_CHECK_ON_PAYMENT_CANCEL: 'xceedance_void_check_on_payment_cancel',
  XCEEDANCE_SUPERVISOR_ONLY_SENT_PAYMENT_CANCEL: 'xceedance_supervisor_only_sent_payment_cancel',
  XCEEDANCE_DEFENSE_ATTORNEY: 'xceedance_defense_attorney',
  QOVER_HIDE_REPORTED_DATE_COLUMN: 'qover_hide_reported_date_column',
  QOVER_HIDE_EXPENSE_INVOICE_NUMBER: 'qover_hide_expense_invoice_number',
  TSC_DISABLE_MANAGED_REPAIR: 'tsc_disable_managed_repair',
  TSC_SMS_ONLY_NUMBER_AUTO_REPLY: 'tsc_sms_only_number_auto_reply',
} as const;

export default LEGACY_ORG_FEATURES;
